<template>
  <v-container fluid class="container-custom">
    <img :src="img" alt="test" class="img-not-found" />
  </v-container>
</template>

<script>
import img from '@/assets/image/page-not-found.png';
export default {
  name: 'Error',
  data: () => ({
    img: img
  })
};
</script>
<style lang="scss">
.container-custom {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-not-found {
  max-width: 30vw;
}
</style>
